module.exports = __webpack_public_path__ + "img/bp_button_normal_kscj.2fdafbc4.png";